// @ts-nocheck
import { useState, useEffect, useCallback } from 'react'
import { zh } from './zh'
import { en } from './en'

export type Locale = 'zh' | 'en'

const translations: Record<Locale, Record<string, any>> = { zh, en }

const STORAGE_KEY = 'clawcustomer_locale'

let currentLocale: Locale = (() => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'en' || stored === 'zh') return stored
  } catch {}
  return 'zh'
})()

const listeners = new Set<() => void>()

export function setLocale(locale: Locale) {
  currentLocale = locale
  try { localStorage.setItem(STORAGE_KEY, locale) } catch {}
  listeners.forEach(fn => fn())
}

export function getLocale(): Locale {
  return currentLocale
}

function resolve(obj: any, path: string): string {
  const keys = path.split('.')
  let val = obj
  for (const k of keys) {
    val = val?.[k]
    if (val === undefined) return path
  }
  return typeof val === 'string' ? val : path
}

// Standalone t() for non-React contexts (e.g., toast messages, callbacks)
export function t(key: string): string {
  return resolve(translations[currentLocale], key)
}

export function useTranslation() {
  const [locale, setLoc] = useState<Locale>(currentLocale)

  useEffect(() => {
    const handler = () => setLoc(currentLocale)
    listeners.add(handler)
    return () => { listeners.delete(handler) }
  }, [])

  const t = useCallback((key: string): string => {
    return resolve(translations[locale], key)
  }, [locale])

  return { t, locale, setLocale }
}
